import { render, staticRenderFns } from "./crm-salary.vue?vue&type=template&id=ac0c2a92&"
import script from "./crm-salary.vue?vue&type=script&lang=js&"
export * from "./crm-salary.vue?vue&type=script&lang=js&"
import style0 from "./crm-salary.vue?vue&type=style&index=0&id=ac0c2a92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports